/**
 * Created by rastwe on 1/26/2017.
 */

import React from 'react';
import envConfig from '@ey/voltron-config';

class Env extends Object {
	/**
	 * Returns true if the environment is production.
	 * @return {boolean} is production
	 */
	static isProd() {
		const env = __NODE_ENV || 'development';
		return env !== 'development';
	}

	/**
	 * Get the Language from the package.json file
	 * @return {String} the language defined in the package file
	 */
	static getLogoutUrl() {
		return envConfig.logoutUrl;
	}

	static getCosmosMaxAllowedCollectionSize() {
		return envConfig.cosmosMaxAllowedCollectionSize;
	}

	static getCosmosMaxAllowedCollectionSizeCanvasEngagements() {
		return envConfig.cosmosMaxAllowedCollectionSizeCanvasEngagements;
	}

	static getCosmosMaxAllowedCollectionSizeFinancialCodes() {
		return envConfig.cosmosMaxAllowedCollectionSizeFinancialCodes;
	}

	/**
	 * Returns the current environment's server URL, appended with
	 * whatever path is passed in as an argument, or just the root
	 * serverURL if path is undefined.
	 * Notice that I'm requiring that all paths be preceeded by a "/"
	 * character. This is because you want any request to the API
	 * root to look like "/", instead of "".
	 * @param {String} path - Path to be appended to the server URL
	 * @return {String} complete path string
	 */
	static getServerUrl(path) {
		let serviceUrl = envConfig.serviceUrl;

		if (path) {
			serviceUrl += path;
		}

		return serviceUrl;
	}

	/**
	 * Get the Language from the package.json file
	 * @return {String} the language defined in the package file
	 */
	static getLanguage() {
		return envConfig.language;
	}

	/**
	 * Gets the correct error message to be displayed
	 * @param {Object} error - the error
	 * @returns {String} the correct message
	 * */
	static getErrorMessage(error) {
		if (error.response) {
			if (error.response.data === '') {
				return error.response.statusText;
			} else if (error.response.data.errorMessage) {
				return error.response.data.errorMessage;
			}
		} else if (error.message && error.message !== '') {
			return error.message;
		} else {
			return error.response.message;
		}
	}

	/**
	 * Removes all html tags. Similar to getting innerText
	 * @param {string} text - the text to cleanup
	 * @returns {string} the cleaned up text
	 * */
	static removeAllHTMLTags(text) {
		return text.replace(/<(?:.|\n)*?>/gm, ' ');
	}

	/**
	 * renders text for tooltip. We may want to remove html tags later.
	 * @param {string} text - the text to cleanup
	 * @returns {string} the cleaned up text
	 * */
	static renderTextForTooltip(text) {
		/*if (text !== undefined && text.length > 0) {
			return text.replace(/<\/?(?!(img)\b)\w+[^>]*>|&nbsp;/gi, '');
		} else {*/
		return text;
		/*}*/
	}
}

export default Env;
